<template>
  <div class="app-container">
    <wt-form-table :form.sync="form" @on-button-action="onButtonAction" ref="generalUserTable">
      <template slot="tableTopCustom" slot-scope="data">
        <div class="table-list-desc">注册用户数量{{form.formResult.totalCount}}（其中已绑定用户{{form.formResult.total}}户）</div>
      </template>
    </wt-form-table>
    <el-dialog
      title="用户二维码"
      :visible.sync="codeDialogVisible"
      :close-on-click-modal="false"
      append-to-body
      :close-on-press-escape="false"
      width="300px"
      key="1"
      :modal="false"
      :before-close="handleDialogClose">
      <div class="general-user-code-container">
        <div ref="qrcode"></div>
        <el-button size="small" @click="downloadCode">下载</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'
let qrcodeFunc = null

export default {
  data() {
    return {
      form: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULE_USER_GENERAL',
        formComponent: {
          view: { type: 'component', componentName: 'GeneralUserView', value: 'queryUserMessageDetailData', noRequest: true },
          add: { type: 'component', componentName: 'UserCustomerPage', value: 'resetUserWechatDetailData' },
          edit: { type: 'component', componentName: 'UserAddPage', value: 'resetUserWechatGeneralUserDetailData' },
          list: { type: 'default', value: '/modules/userWechat/userWechatList' },
          delete: { type: 'default', value: '/modules/userWechat/userWechatDelete' },
          viewDetail: { componentName: 'GeneralUserView' }
        },
        formInputsData: [
          { name: '搜索用户', key: 'keyWord', value: '', type: 'text' },
          { name: '社区', key: 'communityId', value: '', type: 'select', data: [], filterable: true },
          { name: '注册时间', key: 'updateTimeRange', value: [], type: 'datetime' },
          { name: '客户类型', key: 'userType', value: 1, type: 'customAll' }],
        formButtonsData: [{ name: '新增', key: 'EDIT', action: 'EDIT', className: 'primary', permission: 'ADD', hidden: false },
          { name: '二维码下载', key: 'DOWNLOAD', action: 'DOWNLOAD', permission: 'DOWNLOAD', hidden: false }],
        formTableData: [
          { name: '微信昵称', key: 'nickName', type: 'text' },
          { name: '手机号', key: 'phone', type: 'text' },
          { name: '社区', key: 'communityName', type: 'text' },
          { name: '注册时间', key: 'createTime', type: 'text', sortable: 'custom' }],
        formTableButtonsData: [{ name: '成为大客户', key: 'ADD', action: 'ADD', permission: 'EDIT', className: 'primary', hidden: false },
          { name: '查看', key: 'VIEW', action: 'VIEW', className: 'primary', hidden: false, permission: 'VIEW' },
          { name: '删除', key: 'DELETECONFIRM', action: 'DELETECONFIRM', permission: 'DELETE', className: 'danger', hidden: false },
          { name: '用户二维码', key: 'CODE', action: 'CODE', className: 'primary', permission: 'DOWNLOAD', hidden: false }],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: true, index: true, buttonMinWidth: 320, buttonWidth: 320 }
      },
      codeDialogVisible: false,
      currentRow: {}
    }
  },
  mounted() {
    this.requestcommunityList()
  },
  methods: {
    /*  ------------------------- 按钮相关  -------------------------  */
    onButtonAction(data) {
      console.log('data', data)
      const that = this
      if (data && data.item) {
        if (data.item.action === 'VIEW') {
          this.$store.dispatch('setUserWechatCustomerId', data.row.id)
          this.$store.dispatch('setUserWechatDetailData', JSON.parse(JSON.stringify(data.row)))
        }
        if (data.item.action === 'ADD') {
          this.$store.dispatch('setUserWechatCustomerId', data.row.id)
        }
        if (data.item.action === 'DELETECONFIRM') {
          this.$prompt('请输入登录密码', '确认删除提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputType: 'password',
            inputPattern: /\S/,
            inputErrorMessage: '登录密码不能为空'
          }).then(({ value }) => {
            that.$api.userWechat.userWechatDelete({
              id: data.row.id,
              password: value
            }).then(res => {
              that.$refs.generalUserTable.requestFormList()
            })
          }).catch(() => {})
        }
        if (data.item.action === 'EDIT') {
          this.$store.dispatch('resetUserWechatDetailData')
        }
        if (data.item.action === 'CODE') {
          this.currentRow = data.row
          this.userWeChatQRCode(data.row.id)
        }
        if (data.item.action === 'DOWNLOAD') {
          if (this.form.formSelectedList && this.form.formSelectedList.length > 0) {
            const that = this
            const timer = (new Date()).getTime()
            const ids = []
            for (const item of this.form.formSelectedList) {
              ids.push({ id: item.id })
            }
            this.$wtUtil.downloadFile({
              url: window.wtConst.BASE_API + '/modules/userWechat/userWeChatQRCodeList',
              data: ids,
              fileName: '普通用户二维码' + timer + '.zip'
            }).then((res) => {
              console.log('导出成功')
            }).catch((err) => {
              that.$message({ message: err, type: 'error' })
            })
          } else {
            this.$message.warning('请选择需要下载的数据')
          }
        }
      }
    },
    handleDialogClose() {
      this.codeDialogVisible = false
      if (qrcodeFunc) {
        qrcodeFunc.clear()
      }
    },
    downloadCode() {
      var canvasData = this.$refs.qrcode.getElementsByTagName('canvas')
      var a = document.createElement('a')
      var event = new MouseEvent('click')
      a.href = canvasData[0].toDataURL('image/png')
      a.download = this.currentRow.nickName + (this.currentRow.phone ? this.currentRow.phone : '')
      a.dispatchEvent(event)
    },
    /*  ------------------------- 接口请求  -------------------------  */
    requestcommunityList() {
      this.$api.community.communityNoPageList().then(res => {
        for (const item of res.data) {
          item.label = item.name
          item.value = item.id
        }
        this.form.formInputsData[1].data = res.data
      })
    },
    // 用户二维码
    userWeChatQRCode(id) {
      this.$api.userWechat.userWeChatQRCode({
        id: id
      }).then(res => {
        this.codeDialogVisible = true
        this.$nextTick(() => {
          if (!qrcodeFunc) {
            this.qrcode('qrcode', res.data, 100, 100)
          } else {
            qrcodeFunc.clear()
          }
          qrcodeFunc.makeCode(res.data)
        })
      })
    },
    /*  ------------------------- 方法  -------------------------  */
    qrcode(id, code, w, h) {
      qrcodeFunc = new QRCode(this.$refs.qrcode, {
        text: code,
        width: 248,
        height: 248,
        colorDark: '#000000',
        colorLight: '#FFFFFF',
        correctLevel: QRCode.CorrectLevel.H
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.table-list-desc {
  padding: 20px;
  color: #333333;
  font-size: 14px;
}
.general-user-code-container {
  text-align: center;
  .el-image {
    width: 180px;
    height: 180px;
  }
  .el-button {
    display: block;
    margin: 10px auto 0;
  }
}
</style>
